export enum ObjectStatus {
  New = 1,
  Used = 2,
}

export const objectStatusValues: { [id: number]: string } = {
  1: 'Nuevo',
  2: 'Usado',
};

export namespace ObjectStatus {
  export function items() {
    var items = Object.keys(ObjectStatus)
      .filter((type) => isNaN(<any>type) && type !== 'values')
      .map((key, index) => {
        return { key: objectStatusValues[+index + 1], value: +index + 1 };
      });

    return items.filter((x) => x.key != undefined);
  }
}
